import { AnimationVariants } from "@di-devs/base-components";
import { Col, Divider, Row } from "antd";
import { motion } from "framer-motion";
import type React from "react";
import type { MemberAttribute } from "../../../../shared/types/member.types";
import { useMemberAttributeContext } from "../../providers/MemberAttributeContext";
import type { MemberAttributeFilterConfig } from "./types";

export const FilterWrapper: React.FC<{
	children: React.ReactNode;
	itemKey: string;
	memberAttribute?: MemberAttribute;
	config?: MemberAttributeFilterConfig;
}> = (props) => {
	const { children, itemKey } = props;
	const memberAttributeContext = useMemberAttributeContext();
	const memberAttribute =
		props.memberAttribute || memberAttributeContext.memberAttribute;
	const config = props.config || memberAttributeContext.config;

	if (config.layout === "grid" && config.enableAnimation) {
		const MotionCol = motion(Col);
		return (
			<MotionCol
				key={itemKey}
				variants={AnimationVariants.StaggerItem}
				xs={{ span: config.gridColumns?.xs || 24 }}
				md={{ span: config.gridColumns?.md || 12 }}
				lg={{ span: config.gridColumns?.lg || 6 }}
				xl={{ span: config.gridColumns?.xl || 6 }}
			>
				{children}
			</MotionCol>
		);
	}

	if (config.layout === "grid") {
		return (
			<Col
				key={itemKey}
				xs={{ span: config.gridColumns?.xs || 24 }}
				md={{ span: config.gridColumns?.md || 12 }}
				lg={{ span: config.gridColumns?.lg || 6 }}
				xl={{ span: config.gridColumns?.xl || 6 }}
			>
				{children}
			</Col>
		);
	}

	let dividerLabel = config.dividerLabel || "";
	if (memberAttribute?.label) {
		dividerLabel = `${memberAttribute?.label}で検索`;
	}

	return (
		<div key={itemKey}>
			{config.showDividers && <Divider>{dividerLabel}</Divider>}
			<Row gutter={[16, 16]} justify="start">
				<Col xs={{ span: 24 }}>{children}</Col>
			</Row>
		</div>
	);
};
